<div class="popup-container p-3">
  <h2 class="message">
    {{message|translate}}
  </h2>

</div>


